class CustomDirectionsRenderer {
  id: string
  renderer: google.maps.DirectionsRenderer
  data: { [key: string]: any }
  directionsChangedListener: Function | null

  // eslint-disable-next-line space-before-function-paren
  constructor(id: string, renderer: google.maps.DirectionsRenderer, data: { [key: string]: any }) {
    this.id = id
    this.renderer = renderer
    this.data = data
    this.directionsChangedListener = null
  }

  setDirection = (renderer: google.maps.DirectionsRenderer) => {
    this.renderer = renderer
  }

  setDirectionsChangedListener = (callback: Function | null) => {
    if (typeof callback === 'function') {
      return callback
    }

    return () => {
      console.log('route updated')
    }
  }
}

export default CustomDirectionsRenderer
